import { render, staticRenderFns } from "./AssignmentButtons.vue?vue&type=template&id=befc9372&scoped=true&"
import script from "./AssignmentButtons.vue?vue&type=script&lang=js&"
export * from "./AssignmentButtons.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentButtons.vue?vue&type=style&index=0&id=befc9372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc9372",
  null
  
)

export default component.exports